module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery4-aa94bf8acd9333489b62b51bcbef50d1.jpg";